import React from 'react'
import { Link } from "gatsby"
import { Col, Container, Row } from 'react-bootstrap'
import ScheduleCallIcon from '../icon/scheduleCallIcon'
import '../../sass/global/mobileHeaderNav.scss'

const MobileHeaderNav = () => {
    return(
        <div className="overlay" id="overlay">
            <Container>
                <Row>
                    <Col xs={12}
                     className="nav-link-overlay">
                        <p><Link to="/case-studies/" title="Case studies">Work</Link></p>
                        <p><Link to="/branding/">Branding</Link></p>
                        <p><Link to="/animated-explainer-video/">Explainer Video</Link></p>
                        <p><Link to="/about">About</Link></p>
                        <p><Link to="/blog">Blog</Link></p>
                        <p><Link to="/contact">Contact</Link></p>
                    </Col>
                    <Col xs={12}>
                        <div className='get-in-touch mt-5'>
                            <span className='mb-1'>Get in Touch</span>
                            <p className="mailto mb-5"><a href="mailto:hello@wowmakers.com">hello@wowmakers.com</a></p>
                            <a href="#CQL" className="btn yellow drift-chat-popup" >
                                <ScheduleCallIcon />
                                <span>Schedule a call</span>
                            </a>
                        </div>
                    </Col>
                    <Col className="menu-social">
                        <Row>
                            <Col className="text-center social-media">
                                <a href="https://www.facebook.com/WowMakers/" className="social-link facebook" title="WowMakers facebook url"  target="_blank" rel="noreferrer" >
                                    <img src="/footer-social-media-icon/fb-footer.png" alt="" width="55" height="55" loading="lazy"/>
                                </a>
                            </Col>
                            <Col className="text-center social-media">
                                <a href="https://twitter.com/wowmakers/" className="social-link twitter" title="WowMakers Twitter url"  target="_blank" rel="noreferrer" >
                                    <img src="/footer-social-media-icon/twitter-footer.png" alt="" width="55" height="55" loading="lazy"/>
                                </a>
                            </Col>
                            <Col className="text-center social-media">
                                <a href="https://www.instagram.com/wowmakers/" className="social-link instagram" title="WowMakers Instagram url"  target="_blank" rel="noreferrer" >
                                    <img src="/footer-social-media-icon/insta-footer.png" alt="" width="55" height="55" loading="lazy"/>
                                </a>
                            </Col>
                            <Col className="text-center social-media">
                                <a href="https://www.linkedin.com/company/wowmakers/" className="social-link linkedin" title="WowMakers LinkedIn url"  target="_blank" rel="noreferrer" >
                                    <img src="/footer-social-media-icon/linkedin-footer.png" alt="" width="55" height="55" loading="lazy"/>
                                </a>
                            </Col>
                            <Col className="text-center social-media">
                                <a href="https://dribbble.com/wowmakers" className="social-link dribble" title="WowMakers Dribble url"  target="_blank" rel="noreferrer" >
                                    <img src="/footer-social-media-icon/dribble-footer.png" alt="" width="55" height="55" loading="lazy"/>
                                </a>
                            </Col>
                            <Col className="text-center social-media">
                                <a href="https://www.youtube.com/user/wowmakerschannel/" className="social-link youtube" title="WowMakers Youtube channel"  target="_blank" rel="noreferrer" >
                                    <img src="/footer-social-media-icon/youtube-footer.png" alt="" width="55" height="55" loading="lazy"/>
                                </a>
                            </Col>                                                                                    
                        </Row>
                    </Col>                    
                </Row>
            </Container>
        </div>        
    )
}

export default MobileHeaderNav